"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _useCurrentState = _interopRequireDefault(require("../use-current-state"));

const useInput = initialValue => {
  const [value, setValue, currentRef] = (0, _useCurrentState.default)(initialValue);
  return {
    value,
    setValue,
    currentRef,
    reset: () => setValue(initialValue),
    bindings: {
      value,
      onChange: event => {
        if (typeof event === 'object' && event.target) {
          setValue(event.target.value);
        } else {
          setValue(event);
        }
      }
    }
  };
};

var _default = useInput;
exports.default = _default;
module.exports = exports.default;